import { Injectable } from '@angular/core';
import { EnvironmentConfig } from '@src/app/configs/environment.config';
import { fixedEnvironment } from '@src/environments/environment.fixed';

@Injectable({
  providedIn: 'root',
})
export class LoginServiceConfig {
  // These can be configured using the
  // FrontendCoreModule.forRoot static method
  public loginUrl = ''; // ie. 'http://localhost:9000/api/login';
  public logoutUrl = ''; // ie. 'http://localhost:9000/api/logout';
  public mfaUrl = ''; // ie. 'http://localhost:9000/api/mfa';
  public refreshAccessTokenUrl = ''; // ie. 'http://localhost:9000/api/refreshToken';
  public accessTokenHeader = ''; // used in access.interceptor
  public cookieName = ''; // ie. 'AppName_Session';
}

export function createLoginServiceConfig(env?: EnvironmentConfig): LoginServiceConfig {
  const config = new LoginServiceConfig();

  if (env) {
    if (env.backendUrl) {
      config.loginUrl = `${env.backendUrl}/graphql/login`;
      config.logoutUrl = `${env.backendUrl}/graphql/logout`;
      config.mfaUrl = `${env.backendUrl}/graphql/mfa`;
      config.refreshAccessTokenUrl = `${env.backendUrl}/graphql/refreshToken`;
    }
    if (fixedEnvironment.accessTokenHeader) {
      config.accessTokenHeader = fixedEnvironment.accessTokenHeader;
    }
    if (fixedEnvironment.sessionCookieName) {
      config.cookieName = fixedEnvironment.sessionCookieName;
    }
  }

  return config;
}
